import React from "react";
import styles from "./Home.module.css";
import Avatar from "../../../components/common/Avatar";
import { dayName } from "../../../utils/weekDates";

// Date badge + title + sub line; shared by the team deadlines list and My work.
export default function DeadlineRow({ date, today, overdue, title, sub, ownerName, ownerAvatarUrl, onClick }) {
  const isToday = date === today;
  return (
    <div className={styles.dl} onClick={onClick} role={onClick ? "button" : undefined}>
      <div className={`${styles.dlBadge} ${overdue ? styles.dlOverdue : isToday ? styles.dlToday : ""}`}>
        {isToday ? "TODAY" : dayName(date).toUpperCase()}
        <b>{Number(date.slice(8))}</b>
      </div>
      <div className={styles.dlBody}>
        <div className={styles.dlTitle}>{title}</div>
        <div className={styles.dlSub}>{sub}</div>
      </div>
      {ownerName && <Avatar name={ownerName} imageUrl={ownerAvatarUrl} round />}
    </div>
  );
}
